import { linearGradient } from '../../../../internal/styles/linearGradient';
import { type BannerBoxTokens } from '../types';

export const bannerBox: BannerBoxTokens = {
  colors: {
    borderTop: 'secondary.50',
    background: null,
    background2: '#F5F5F5',
    background5: '#66C431',
  },
  backgroundImage: {
    base: 'url(/images/onefront/bluestone/GV/govoyages_app_background.png)',
    gradient: linearGradient('90deg', ['#123300', '#0B1F00']),
  },
};
